export const toCurrency = (number = 0, minFraction = 0, maxFraction = 2) =>
  new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: minFraction,
    maximumFractionDigits: maxFraction,
  })
    .format(number)
    .replace(/\D00$/, '')
